import React from 'react';
import {Spinner} from 'react-bootstrap'

const Loader = () => <Spinner className="d-flex mx-auto justify-content-center m-3" animation="border" variant="secondary" />

export default Loader;
